import $ from 'jquery';

if ($('.p-vision').length) {
  const $w = $(window);
  const $visionFixed = $('.js-bg');
  const $visionFixedDiv = $('.js-bg > div');
  const visionFixedDivLength = $visionFixedDiv.length;
  const $visionFireBg = $('.js-fixed-bg');
  const $visionCon = $('.p-vision__sec');
  const $visionFixedPage = $('.js-vision-pagination');
  const $visionFixedPageButton = $visionFixedPage.find('button');

  $w.on('load scroll', function () {
    let winSc = $w.scrollTop();
    let target = $('.p-vision__content').offset().top;

    if (winSc > target) {
      $visionFixed.addClass('is-fixed');
      $visionFixedPage.addClass('is-fixed');
    } else {
      $visionFixed.removeClass('is-fixed');
      $visionFixedPage.removeClass('is-fixed');
    }

    $visionFireBg.each(function (i) {
      let $this = $(this);
      let start = $this.offset().top - $w.height() / 2;
      if (i == visionFixedDivLength - 1) {
        if (winSc >= start) {
          let thisId = $this.attr('id');
          $visionFixedDiv.not('[data-id="' + thisId + '"]').fadeOut(1000);
          $('.p-vision__bg div[data-id="' + thisId + '"]').fadeIn(1000);
        }
      } else {
        let $thisNext = $this.next();
        let startNext = $thisNext?.offset()?.top - $w.height() / 2;
        if (winSc >= start && winSc < startNext) {
          let thisId = $this.attr('id');
          $visionFixedDiv.not('[data-id="' + thisId + '"]').fadeOut(1000);
          $('.p-vision__bg div[data-id="' + thisId + '"]').fadeIn(1000);
        }
      }
    });

    $visionCon.each(function (i) {
      let $this = $(this);
      let start = $this.offset().top - $w.height() / 2;
      let thisHeight = $this.outerHeight();
      if (winSc > start && winSc < start + $this.height()) {
        $visionFixedPageButton.removeClass('is-active');
        $visionFixedPageButton.eq(i).addClass('is-active');
        $visionFixedPageButton
          .eq(i)
          .find('circle')
          .css({
            'stroke-dasharray': (80 / thisHeight) * (winSc - start) + ',266',
          });
      }
    });
  });

  $visionFixedPageButton.on('click', function () {
    let $this = $(this);
    let target = $('#' + $this.attr('data-id')).offset().top;
    $('html,body').animate(
      { scrollTop: target - $('.js-header').height() },
      400,
    );
  });
}
